

export interface INotification {
    id: number
    date: Date
    isRead: boolean
    message:string
    notificationType: NotificationType
    isImportant: boolean
    isVoiceEnable: boolean
    entityId?: string
    customerName?: string
}

export interface IUpdateReadStatusNotifications{
    ids: number[]
    isRead: boolean
}

export interface IInformationNotification{
    message: string
    isImportant: boolean
    clientIds?: number[]
}

export interface ICountEntityVerificationCatalog{
    countTranspoert:number
    countDriver:number
    countDeliveryAddress:number
}

export interface INotificationRecipientCustomer {
  CustomerId: number;
  CustomerName: string;
}

export enum NotificationType{
    changeOrderStatus = 0,
    informationAllUsers = 1,
    updateCatalogData = 2,
    timeUnloadFuelSlotRelease = 3,
    updateDriverCatalog = 4,
    updateTransportCatalog = 5,
    UpdateAddressCatalog = 6,
    UpdateFuelLimit = 7,
    UpdateFuelPrice = 8,
    NewReturnFundRequest = 9,
    UpdateReturnFundRequest = 10,
    BulkOrder = 11,
    TimerBulkOrder = 12,
    RedFlagOrderType = 13
}

export const NOTIFICATION_KEY = "NOTIFICATION_KEY"